<template>
  <div>
    <div class="flex justify-between text-right">
      <div class="inline-flex mt-2" v-if="showRangeDate">
        <p v-if="params.interval === 'range'">
          Data selecionada:
          <b>{{ params.date_from | smallDate }} - {{ params.date_to | smallDate }}</b>
        </p>
      </div>
      <div class="inline-flex rounded-md" role="group">
        <div class="border border-gray-200 rounded-lg overflow-hidden">
          <button
            v-for="button in buttons"
            :key="button.key"
            type="button"
            class="border-r border-gray-200 shadow-sm py-3 px-4 text-sm font-medium text-gray-900 bg-white hover:bg-yellow-300 hover:text-gray-800"
            :class="{ 'bg-yellow-400': itemSelected.includes(button.key) }"
            @click="changeFilter(button.key)"
          >
            {{ button.name }}
          </button>
        </div>
        <button
          v-if="showIconDate"
          type="button"
          class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-200 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:shadow-outline-gray focus:border-gray-300 active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150 shadow-sm"
          v-tippy
          content="Filtre por data"
          @click="modalDataFilter = true"
        >
          <svg class=" h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
            <path
              fill-rule="evenodd"
              d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
      </div>
    </div>
    <div class="flex items-center gap-4" v-if="selectedButton">
        <span class="flex items-center mt-2 px-2 py-1 text-sm font-medium text-gray-700 bg-gray-200 rounded-full">
            Filtro selecionado:  <strong class="ml-1"> {{ selectedButton.name }}</strong>
            <em class="ml-2 fas fa-times-circle cursor-pointer" @click="clearSelectedButton" />
        </span>
    </div>
    <jet-dialog-modal :show="modalDataFilter" @close="modalDataFilter = false" :height="'h-auto'">
      <template #title> Filtrar por data </template>
      <template #content>
        <div class="grid grid-cols-12 gap-4 ">
          <div class="col-span-6">
            <label class="block text-gray-700 text-sm font-bold mb-2"> Data inicial </label>
            <jet-date-picker
              id="date_start"
              class="mt-1 block w-full"
              v-model="dateRange.startDate"
              :disabled-dates="{ from: moment().toDate() }"
            />
            <jet-input-error :message="formErrors.startDate" class="mt-2" />
          </div>
          <div class="col-span-6" v-if="dateTimer">
            <label class="block text-gray-700 text-sm font-bold mb-2"> Hora inicial </label>
            <input
              id="time_start"
              class="mt-1 rounded-md border border-solid border-black text-gray-700 w-full my-1 py-2 px-3 block"
              type="time"
              step="2"
              v-model="dateRange.startTime"
            />
            <jet-input-error :message="formErrors.startTime" class="mt-2" />
          </div>
          <div class="col-span-6">
            <label class="block text-gray-700 text-sm font-bold mb-2"> Data final </label>
            <jet-date-picker
              id="date_end"
              class="mt-1 block w-full"
              v-model="dateRange.endDate"
              :disabled-dates="{ from: dateNow }"
            />
            <jet-input-error :message="formErrors.endDate" class="mt-2" />
          </div>
          <div class="col-span-6" v-if="dateTimer">
            <label class="block text-gray-700 text-sm font-bold mb-2"> Hora final </label>
            <input
              id="time_end"
              class="mt-1 rounded-md border border-solid border-black text-gray-700 w-full my-1 py-2 px-3 block"
              type="time"
              step="2"
              v-model="dateRange.endTime"
            />
            <jet-input-error :message="formErrors.endTime" class="mt-2" />
          </div>
        </div>
      </template>
      <template #footer>
        <div class="flex justify-between">
            <jet-secondary-button @click.native="modalDataFilter = false">
            Cancelar
            </jet-secondary-button>
            <jet-button class="ml-2" @click.native="changeFilterDate()"> Filtrar </jet-button>
        </div>
      </template>
    </jet-dialog-modal>
  </div>
</template>
<script>
import JetDialogModal from "../../Jetstream/DialogModal.vue";
import JetDatePicker from "../../Jetstream/DatePicker.vue";
import JetSecondaryButton from "../../Jetstream/SecondaryButton.vue";
import JetInputError from "../../Jetstream/InputError.vue";
import JetButton from "../../Jetstream/Button.vue";
import moment from 'moment';

export default {
  props: {
    filter: {
      type: [String, Array],
      default: "range"
    },
    routeName: {
      type: String,
      default: ""
    },
    dateTimer: {
      type: Boolean,
      default: true
    },
    buttons: {
      type: Array,
      required: true
    },
    treatDates: {
      type: [Function, null],
      default: null
    },
    showRangeDate: {
      type: Boolean,
      default: true
    },
    showIconDate: {
      type: Boolean,
      default: true
    }
  },
  components: {
    JetDialogModal,
    JetDatePicker,
    JetSecondaryButton,
    JetInputError,
    JetButton
  },
  data() {
    return {
      moment,
      selectedButton: null,
      modalDataFilter: false,
      filterSelected: this.filter,
      formErrors: {},
      dateRange: {
        startDate: null,
        startTime: "00:00:00",
        endDate: null,
        endTime: "23:59:59"
      },
      params: {
        sort: "name:asc",
        page: 1,
        ...this.$page.props.queryString
      }
    };
  },
  created() {
    this.selectedButton = this.buttons.find(button => button.key === this.$page.props.queryString.interval) ?? null
  },
  computed: {
    dateNow() {
        return moment().toDate() || null
    },
    itemSelected(){
      if(!Array.isArray(this.filter)){
        return [this.filter]
      }
      return this.filter
    }
  },
  methods: {
    clearErrors() {
      this.formErrors = {
        startDate: null,
        startTime: null,
        endDate: null,
        endTime: null
      };
    },

    clearSelectedButton() {
      this.selectedButton = null;
      this.$inertia.get(this.route(this.$page.props.currentRouteName))
    },
    changeFilter(filterSelected) {
      if (this.itemSelected.includes(filterSelected)) {
        return;
      }
      if (this.treatDates) {
        this.treatDates(this, filterSelected);
        return;
      }
      this.selectedButton = this.buttons.find(button => button.key === filterSelected);
      this.goRoute({ interval: filterSelected });
    },
    goRoute(params) {
      this.$inertia.get(
        this.route(this.routeName, params)
      );
    },
    changeFilterDate(interval) {
      let isValid = true;
      this.clearErrors();
      if (this.dateRange.startDate > this.dateRange.endDate) {
        this.formErrors.startDate = "Data inicial não pode ser maior que a data final";
        isValid = false;
      }
      if (!this.dateRange.startDate) {
        this.formErrors.startDate = "Data inicial é obrigatória";
        isValid = false;
      }
      if (!this.dateRange.endDate) {
        this.formErrors.endDate = "Data final é obrigatória";
        isValid = false;
      }
      if (!this.dateRange.startTime) {
        this.formErrors.startTime = "Hora inicial é obrigatória";
        isValid = false;
      }
      if (!this.dateRange.endTime) {
        this.formErrors.endTime = "Hora final é obrigatória";
        isValid = false;
      }
      if (!isValid) {
        return;
      }
      let params = {
        date_from: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        time_from: this.dateRange.startTime,
        date_to: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        time_end: this.dateRange.endTime,
        interval: interval ? interval : "range"
      };
      if (!this.dateTimer) {
        delete params.time_from;
        delete params.time_end;
      }
      this.$inertia.get(this.route(this.routeName, {...this.$page.props.queryString,...params}));
    }
  }
};
</script>
